module.exports = __webpack_public_path__ + "static/media/up-arrow-svgrepo-com (1).69cca105.svg";